module.exports = __webpack_public_path__ + "img/sui4.4317318d.png";